import { useContext } from "react";

import "react-multi-date-picker/styles/layouts/prime.css";
import Select from "react-select";

import ModalContext from "./ModalContext";

export default function Filter({ order }) {
  const { searchData, selectedSearchData, SelectedSDHandler } =
    useContext(ModalContext);

  return (
    <div className="filter-container">
      <div className="title">
        <span className="ps-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 33 30"
          >
            <path
              id="Icon_feather-filter"
              data-name="Icon feather-filter"
              d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z"
              transform="translate(-1.5 -3)"
              fill="none"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="3"
            />
          </svg>
        </span>

        <span className="ps-2">فیلتر فاکتور ها</span>
      </div>
      <div>
        <div className="filter-item flex-wrap mx-2 justify-content-center justify-content-lg-start row">
          <div
            className={
              "search-box mt-3 align-items-center row col-12 col-md-6" +
              (!order ? " col-xxl-4" : "")
            }
          >
            <label className="col-4">انتخاب تور </label>
            <div className="col-8">
              <Select
                isClearable
                options={searchData.tours}
                onChange={(value) => {
                  SelectedSDHandler("tourId", value != null ? value.value : -1);
                }}
                value={
                  selectedSearchData.tourId == -1
                    ? null
                    : searchData.tours.find(
                        (value) => value.value == selectedSearchData.tourId
                      )
                }
              />
            </div>
          </div>
          <div
            className={
              "search-box mt-3 align-items-center row col-12 col-md-6" +
              (!order ? " col-xxl-4" : "")
            }
          >
            <label className="col-4">انتخاب مسافرین</label>
            <div className="col-8">
              <Select
                isClearable
                closeMenuOnSelect={false}
                isMulti
                options={searchData.users}
                onChange={(value) => {
                  SelectedSDHandler(
                    "userIds",
                    value.map((val) => val.value)
                  );
                }}
                value={
                  selectedSearchData.userIds.length == 0
                    ? null
                    : searchData.users.filter((value) =>
                        selectedSearchData.userIds.includes(value.value)
                      )
                }
              />
            </div>
          </div>
          <div
            className={
              "search-box mt-3 align-items-center row col-12 col-md-6" +
              (!order ? " col-xxl-4" : "")
            }
          >
            <label className="col-4">انتخاب وضعیت پرداخت </label>
            <div className="col-8">
              <Select
                isClearable
                options={searchData.payment}
                onChange={(value) => {
                  SelectedSDHandler(
                    "paymentVal",
                    value != null ? value.value : -1
                  );
                }}
                value={
                  selectedSearchData.paymentVal == -1
                    ? null
                    : searchData.payment.find(
                        (value) => value.value == selectedSearchData.paymentVal
                      )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
